import z from "zod";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationRecRuleTicketDefDoc.errors.";

const sendWhenSchema = z.object(
  {
    id: z.string(),
    name: z.string().optional().nullable(),
    code: z.string().optional().nullable(),
  },
  { invalid_type_error: translationPath + "send_when" }
);

const ticketDefaultDocSchema = z.object(
  {
    id: z.string(),
    name: z.string().optional().nullable(),
  },
  { invalid_type_error: translationPath + "ticket_default_doc" }
);

const ticketAutRecRuleTicketDefDocsInternalProcedureSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const ticketAutRecRuleTicketDefDocsInsuranceSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const ticketAutRecRuleTicketDefDocsCalendarsSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const automationRecRuleTicketDefDocSchema = z.object({
  enable: z.boolean(),
  sendWhen: sendWhenSchema,
  ticketDefaultDoc: ticketDefaultDocSchema,
  description: z.string().nullish(),
  ticketAutRecRuleTicketDefDocsInternalProcedures: z
    .array(ticketAutRecRuleTicketDefDocsInternalProcedureSchema)
    .nullish(),
  ticketAutRecRuleTicketDefDocsInsurances: z
    .array(ticketAutRecRuleTicketDefDocsInsuranceSchema)
    .nullish(),
  ticketAutRecRuleTicketDefDocsCalendars: z
    .array(ticketAutRecRuleTicketDefDocsCalendarsSchema)
    .nullish(),
});

export type AutomationRecRuleTicketDefDocForm = z.infer<
  typeof automationRecRuleTicketDefDocSchema
>;
